<template>
    <div class="row g-2">
        <div :class="showUnit? 'col-md-9' : 'col-md-12'">
            <label for="temporisation" class="form-label">{{ label }}</label>
            <div class="d-flex align-items-center">
                <input type="range" class="form-range me-2" id="temporisation" :min="min" :max="max" v-model.number="currentValue" />
                <input type="number" class="form-control form-control-sm" style="width: 75px;" :min="min" :max="max" v-model.number="currentValue" />
            </div>
            <div v-if="value === 0" class="form-text text-success">{{ effectiveTextIfZero }}</div>
            <div v-else class="form-text">{{ currentText }}</div>
        </div>
        <div v-if="showUnit" class="col-md-3">
            <label for="temporisation-unit-sel" class="form-label">{{ $t('common.unit') }}</label>
            <select class="form-select form-select-sm" id="temporisation-unit-sel" v-model="currentUnit">
                <option value="h">{{ $t('tempo.hours') }}</option>
                <option value="m">{{ $t('tempo.minutes') }}</option>
                <option value="s">{{ $t('tempo.seconds') }}</option>
            </select>
        </div>
    </div>
</template>

<script>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

export default {
    name: 'TempoWithUnit',
    props: {
        label: { type: String, required: true },
        value: { type: Number, required: true },
        unit: { type: String, required: true },
        min: { type: Number, required: true },
        max: { type: Number, required: true },
        showUnit: { type: Boolean, default: true },
        textIfZero: { type: String, default: null }
    },
    emits: ['update:value', 'update:unit'],
    setup(props, { emit }) {
        const { t } = useI18n();

        const effectiveTextIfZero = computed(() => props.textIfZero ?? t('common.disabled'));

        const currentValue = computed({
            get() {
                return Math.min(Math.max(props.value, props.min), props.max);
            },
            set(val) {
                emit('update:value', Number(val));
            }
        });

        const currentUnit = computed({
            get() { return props.unit; },
            set(val) { emit('update:unit', val); }
        });

        const currentText = computed(() => {
            let unit;
            switch (props.unit) {
                case 's': unit = t('tempo.seconds'); break;
                case 'm': unit = t('tempo.minutes'); break;
                case 'h': unit = t('tempo.hours'); break;
                default: unit = props.unit;
            }
            return t('tempo.duration', { value: currentValue.value, unit });
        });

        return { effectiveTextIfZero, currentValue, currentUnit, currentText };
    }
}
</script>
